import { NgModule } from '@angular/core';
import { IframeBannerComponent } from '@lti/app/components/iframe-banner/iframe-banner.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule
	],
	exports: [
		IframeBannerComponent
	],
	declarations: [
		IframeBannerComponent
	]
})
export class IframeBannerModule {}
